import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="w-full border-b border-t dark:border-white/10 flex flex-col py-16 md:py-20 items-center text-sky-800 bg-gray-100 dark:bg-content bg-center bg-cover dark:text-white">
      <div className="w-11/12 md:w-10/12 gap-5 grid lg:grid-cols-3">
        <div>
          <h1 className="text-3xl dark:text-sky-500 font-bold">GDSC UIT</h1>
          <p className="mt-2 text-sm">
          The main agenda of DSC is to help students maintain a proper balance between their theory work and practical work. Being a good student does not only depend upon how much you are good at your studies, but it also focuses on your determination and passion for learning something and implementing it by bringing innovation to the world.{" "}
          </p>
        </div>
        <div className="lg:pl-5">
          <h1 className="text-lg font-bold dark:text-sky-500">More Links</h1>
          <div className="flex flex-col">
            <PageLink title="About" to="/about" />
            <PageLink title="Team 22-23" to="/team/2023" />
            <PageLink title="Team 21-22" to="/team/2022" />
            <PageLink title="Team 20-21" to="/team/2021" />
          </div>
        </div>

        
        
        <div>
          <h1 className="uppercase text-lg font-bold dark:text-sky-500">
            Follow Us
          </h1>
          <div className="grid grid-cols-4 md:grid-cols-4 gap-3 mt-3">
            <SocialIcon
              title="Instagram"
              img="/img/InstagramLogo.png"
              link="instagram.com/gdscuit/"
            />
            <SocialIcon
              title="LinkedIn"
              img="/img/linkedin.png"
              link="linkedin.com/company/dscuit/"
            />
            <SocialIcon
              title="Facebook"
              img="/img/facebook.png"
              link="facebook.com/gdscuitu"
            />
            <SocialIcon
              title="Twitter"
              img="/img/twitter.png"
              link="twitter.com/dscuit_khi"
            />
          
          </div>
        </div>
      </div>
      <div className="w-11/12 md:w-10/12 mt-16 text-gray-500 border-t pr-10 pb-2 font-medium border-sky-800 dark:border-gray-100 dark:text-white">
        <p>Copyright © 2023 Syed Hamza Hoda, All rights reserved.</p>
      </div>
    </div>
  );
}

function PageLink({ title, to }) {
  return (
    <Link
      to={to}
      className="mt-3 text-black dark:text-white/70 hover:text-sky-800 dark:hover:text-sky-300"
    >
      {title}
    </Link>
  );
}

function SocialIcon({ title, img, link }) {
  return (
    <a
      title={title}
      target="_blank"
      rel="noreferrer"
      href={`https://www.${link}`}
      className="flex items-center justify-center p-3 mr-3 bg-sky-800 dark:bg-sky-500 dark:hover:bg-sky-800 hover:bg-gray-700 cursor-pointer rounded-full"
    >
      <img src={img} className="h-4" alt="" />
    </a>
  );
}
